import { useEffect, useState } from 'react';
import { archiveOrders } from '../../../Services/AdminServices/AdminCommissionServices';
import { getUserSale } from '../../../Services/AdminServices/userSaleServices';
import DataTables from '../../Main/DataTable/DataTables';

const RefferalUserSale = () => {

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    const columns = [
        { name: 'Referal Name', selector: row => row.referrer_name ? row.referrer_name : "-" },
        { name: 'Refferal User Email', selector: row => row.referrer_email ? row.referrer_email : "-" },
        { name: 'Referal Code', selector: row => row.referrer_referral_code },
        { name: 'Total Orders', selector: row => row.total_orders },
        { name: 'Total Sale', selector: row => row.total_sales },
    ];

    const getOrders = async () => {
        setLoading(true)
        const response = await getUserSale();
        if (response?.code === 200) {
            setData(response?.result?.original?.data)
            setLoading(false)
        }
    }

    useEffect(() => { getOrders(); }, [])

    return (


        <>
            <div className="container">
                <div className="row">
                    <div className="col-lg">
                        <h3 className='fw-bold mb-0'>Sale</h3>
                        <p className='text-muted'>Manage Referral User Sale </p>
                    </div>



                    {loading ? (
                        <div style={{ textAlign: 'center', padding: '50px' }}>
                            <div className="spinner-border text-info" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    ) : (
                        <div className="col-lg-12">
                            <DataTables filter={true} columns={columns} data={data} />
                        </div>
                    )}



                </div>
            </div>
        </>
    )
}

export default RefferalUserSale